<style>
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #3fa535;
}

.custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(63, 165, 53, 0.63);
}
th.specification-type {
  text-align: center;
}
th.selected-program-name {
  text-align: center;
}

.table-sanction h4,
h5,
h3 {
  font-weight: bold;
  color: #424242;
}

.table-hover tbody tr.hover-none:hover {
  background-color: white !important;
}
</style>

<template>
    <div>
        <b-modal v-model="show"
                 @hidden="onHidden"
                 ref="modal"
                 size="lg"
                 fadeOutDown
                 okVariant="success"
                 centered
                 v-bind:title="getTitle()"
                 @ok="validate">
            <custom-loader v-if="mechanisms==='' && !ajaxIsDone"></custom-loader>
            <form @submit.stop.prevent="handleSubmit">
                <b-form-group>
                    <transition name="fade">
                        <div class="table-responsive"
                             v-if="mechanisms !==''">
                            <table style="border-collapse: inherit;"
                                   class="table table-sm table-sanction">
                                <thead>
                                    <tr>
                                        <th class="selected-program-name"
                                            width="60%">
                                            <h3>{{selectedProgram.name}}</h3>
                                        </th>
                                        <th width="40%">
                                        </th>
                                    </tr>
                                    <tr>
                                        <th width="60%"><hr></th>
                                        <th class="specification-type"
                                            width="40%">
                                            <h4>Előírás típusa
                                                <sub style="color:red; font-size: 30px;">*</sub>
                                            </h4>
                                            <span style="color:gray;">kötelező/választható</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <table style="border-collapse: inherit;"
                                                   class="table table-hover"
                                                   v-for="(mechanism,mkey) in mechanisms">
                                                <thead>
                                                    <tr>
                                                        <th width="50%">
                                                            <strong class="agrotech"
                                                                    v-if="mkey === 'AGRO_TECHNICAL'">
                                                                <div class="d-flex">
                                                                    <h5 class="pb-4">Agrotechnikai szankciók </h5>
                                                                    <span class="agr-snc-star mb-0 pb-0">*</span>
                                                                </div>
                                                                <small class="text-muted">A támogatói okiratban vállalt választható előírások alapján jelölje be választását!</small>
                                                            </strong>
                                                            <strong v-else-if="mkey === 'STRUCTURE'">
                                                                <h5> Vetésszerkezetre vonatkozó szankciók </h5>
                                                            </strong>
                                                            <strong v-else-if="mkey === 'OTHER'">
                                                                <h5> Egyéb szankciók </h5>
                                                            </strong>
                                                        </th>
                                                        <th width="10%"></th>
                                                        <th width="20%"></th>
                                                        <th width="10%"></th>
                                                        <th width="10%"></th>
                                                    </tr>

                                                </thead>
                                                <tbody v-for="(sanction,key) in mechanism">
                                                    <tr>
                                                        <td colspan="1">
                                                            <p class="align-items-center"
                                                               style="font-style:italic;"> {{sanction.support_requirements}} </p>
                                                        </td>
                                                        <td colspan="1">
                                                            <strong>{{sanction.specification_type ==true ? 'kötelező ':'választható '}}</strong>
                                                        </td>
                                                        <td colspan="1">
                                                            <tbody class="unset-hover">
                                                                <!-- v-if="!sanction.checked_default && mkey != 'STRUCTURE'" -->
                                                                <tr v-if="!sanction.specification_type">
                                                                    <td>
                                                                        <p style="font-style:italic;"
                                                                           class="pull-left text-left">
                                                                            Választotta?
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="mkey != 'STRUCTURE'">
                                                                    <td>
                                                                        <p style="font-style:italic;"
                                                                           class="pull-left text-left"
                                                                           v-if="sanction.control_level == 'TOTAL_KET_AREA'">A KET területének 100% -án, teljesült?</p>
                                                                        <p style="font-style:italic;"
                                                                           class="pull-left text-left"
                                                                           v-if="sanction.control_level == 'TOTAL_AREA'">A terület 100% -án, az összes KET vonatkozásában teljesült?</p>
                                                                        <p style="font-style:italic;"
                                                                           class="pull-left text-left"
                                                                           v-if="sanction.control_level == 'TABLE'">A KET -en belüli táblák megfelelnek a kritériumnak?</p>
                                                                    </td>
                                                                </tr>
                                                            </tbody>

                                                        </td>
                                                        <td colspan="1">
                                                            <tbody class="unset-hover">
                                                                <tr v-if="!sanction.specification_type">
                                                                    <td>
                                                                        <b-form-checkbox :id="'checkbox-chosed-true-'+sanction.id"
                                                                                         v-model="sanction.user_chosed"
                                                                                         value="accepted"
                                                                                         :disabled="sanction.checked_default || (sanctionCeckedYear > parseInt(selectedYear) && !this.isPeriodValidation)"
                                                                                         @change="onChangeEventHandler(sanction,sanction.user_chosed)"
                                                                                         class="mb-2"
                                                                                         unchecked-value="not_accepted">
                                                                            igen
                                                                        </b-form-checkbox>

                                                                    </td>
                                                                </tr>
                                                                <!-- v-if="!sanction.checked_default && mkey != 'STRUCTURE'" -->
                                                                <tr v-if="mkey != 'STRUCTURE'">
                                                                    <td>
                                                                        <b-form-checkbox :id="'checkbox-true-'+sanction.id"
                                                                                         v-model="sanction.user_checked"
                                                                                         value="accepted"
                                                                                         class="mb-2"
                                                                                         :disabled="sanction.checked_default"
                                                                                         unchecked-value="not_accepted">
                                                                            igen
                                                                        </b-form-checkbox>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </td>
                                                        <td colspan="1">
                                                            <tbody v-if="!sanction.checked_default"
                                                                   class="unset-hover">
                                                                <tr v-if="!sanction.specification_type">
                                                                    <td>
                                                                        <b-form-checkbox :id="'checkbox-chosed-false-'+sanction.id"
                                                                                         v-model="sanction.user_chosed"
                                                                                         @change="onChangeEventHandler(sanction,sanction.user_chosed)"
                                                                                         value="not_accepted"
                                                                                         :disabled="sanction.checked_default || (sanctionCeckedYear > parseInt(selectedYear)&& !this.isPeriodValidation)"
                                                                                         class="mb-2"
                                                                                         unchecked-value="accepted">
                                                                            nem
                                                                        </b-form-checkbox>
                                                                        <span v-if="sanctionCeckedYear > parseInt(selectedYear) && !this.isPeriodValidation"
                                                                              class="fa-stack mb-1 fa-stack-info"
                                                                              v-tooltip="'Minden választható szankciónál csak első évben lehet megadni, hogy választotta-e. A következő években már csak a teljesülést tudja módosítani. (Mivel ha választott valamit, akkor azt 5 éves viszonylatban választja). '">
                                                                            <i class="fa fa-circle-thin fa-stack-2x"></i>
                                                                            <i class="fa fa-info fa-stack-1x"></i>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                <!-- v-if="!sanction.checked_default && mkey != 'STRUCTURE'" -->
                                                                <tr v-if="mkey != 'STRUCTURE'">
                                                                    <td>
                                                                        <b-form-checkbox :id="'checkbox-false-'+sanction.id"
                                                                                         v-model="sanction.user_checked"
                                                                                         value="not_accepted"
                                                                                         :disabled="sanction.checked_default"
                                                                                         class="mb-2"
                                                                                         unchecked-value="accepted">
                                                                            nem
                                                                        </b-form-checkbox>
                                                                    </td>
                                                                </tr>
                                                            </tbody>

                                                        </td>
                                                    </tr>

                                                    <tr class="hover-none"
                                                        v-if="checkIsRelation(sanction,mechanism[key+1])">
                                                        <td style="text-align:center;"
                                                            colspan="1">
                                                            <p>
                                                                <strong>vagy</strong>

                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-if="mechanisms == '' && ajaxIsDone"
                             class="alert alert-warning"
                             role="alert">
                            <h4 class="alert-heading">Figyelem!</h4>
                            <p>
                                <strong>
                                    A teljes területet hasznosíthatja a megadott kultúrák közül tetszőleges arányban: (szálas pillangós takarmánynövények, azok füves keveréke, illetve zöldugar).
                                </strong>
                            </p>
                            <hr>
                            <p class="mb-0"> Ha más növénykultúrát is termeszt a szálas pillangós takarmánynövények, azok füves keveréke, ill. zöldugaron túl, vagy ha nem ekként hasznosítja az összes –támogatásban szereplő- területet akkor nem teljesülnek a program feltételei, ezért be kell tartania a vetésszerkezetet, azaz a programoknál szereplő második programtípust, kell választania!
                            </p>
                        </div>
                    </transition>
                </b-form-group>
            </form>
            <div slot="modal-footer"
                 class="w-100">

                <div class="row">
                    <div class="col col-md-8">
                        <p class="float-left">
                            <small>
                                <strong class="text-muted">
                                    <sub style="color:red; font-size: 20px;">*</sub>
                                    Amennyiben szeretné látni, hogy az egyes előírások nem teljesülése esetén milyen szankciókra számíthat, úgy kérjük hogy minden előírásnál válassza ki a megfelelő értéket.
                                </strong>
                            </small>
                        </p>
                    </div>
                    <div class="col col-md-4 float-right">

                        <div class="float-right">
                            <b-btn size="md"
                                   v-bind:disabled= "mechanisms.length == 0"
                                   variant="success"
                                   @click="validate">
                                {{sanctionType=='ANNUALLY' || isPeriodValidation ? 'Szankciószámítás':'Rendben'}}
                            </b-btn>
                            <b-btn size="md"
                                   variant="default"
                                   @click="close">
                                Mégsem
                            </b-btn>
                        </div>
                    </div>

                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import swal from "sweetalert2";
import UserProgram from "../moldels/UserProgram";
import CustomLoader from "./CustomLoader";

export default {
  components: {
    CustomLoader
  },
  props: [
    "selectedYear",
    "selectedProgram",
    "userProgramId",
    "sanctionCeckedYear",
    "sanctionType",
    "isPeriodValidation",
    "totalArea"
  ],
  data() {
    return {
      ajaxIsDone: false,
      mechanisms: "",
      show: true
    };
  },
  computed: {
    selectedIds: function() {
      var selected = [];
      for (var propertyName in this.mechanisms) {
        this.mechanisms[propertyName].forEach(function(mechanism) {
          selected.push({
            id: mechanism.id,
            user_chosed: mechanism.user_chosed,
            user_checked: mechanism.user_checked
          });
        });
      }
      return selected;
    }
  },

  mounted: function() {
    axios
      .get("ajax/akgprogram/mechanisms", {
        params: {
          year: this.selectedYear,
          program: this.selectedProgram.id,
          user_program: this.userProgramId,
          checkedYear: this.sanctionCeckedYear,
          type: this.sanctionType
        }
      })

      .then(({ data }) =>
        setTimeout(() => {
          if (_.isEmpty(data)) {
            this.ajaxIsDone = true;
            return;
          }
          // Ne jelenitsuk meg a veteszerkeyetre vonatkoyo kotelezo mezoket.
          for (var propertyName in data) {
            data[propertyName] = _.filter(data[propertyName], function(
              mechanism
            ) {
              return !(
                mechanism.specification_type == 1 &&
                mechanism.type == "STRUCTURE"
              );
            });

            if (data[propertyName].length == 0) {
              delete data[propertyName];
            }
          }
          this.mechanisms = data;
          this.ajaxIsDone = true;
        }, 500)
      )
      .catch(function() {
        console.log("Az mekhanizmusok lekerese nem sikerult!");
      });
  },

  methods: {
    onChangeEventHandler(mechanism, oldData) {
      if (
        mechanism.is_manure &&
        (oldData == false || oldData == "not_accepted")
      ) {
        swal({
          type: "warning",
          title: "Figyelem!",
          html:
            "Bármely trágyázási mód választása egy évben csak egy eseménynek ismerhető el!",
          confirmButtonColor: "#3fa535",
          confirmButtonText: "Rendben"
        });
      }

      if (mechanism.dependency_mechanism_id === null) {
        return;
      }

      for (var propertyName in this.mechanisms) {
        var relatedMechanism = _.find(this.mechanisms[propertyName], function(
          m
        ) {
          if (m.id == mechanism.dependency_mechanism_id) {
            m.valid = true;
            mechanism.valid = true;
          }
          return m.id == mechanism.dependency_mechanism_id;
        });

        if (typeof relatedMechanism == "undefined") {
          continue;
        } else {
          break;
        }
      }

      if (relatedMechanism.user_chosed == "accepted") {
        relatedMechanism.user_chosed = "not_accepted";
      }
    },

    validate(evt) {
      // Prevent modal from closing
      evt.preventDefault();
      var isValid = true;
      var selected = [];
      var vm = this;

      for (var propertyName in this.mechanisms) {
        this.mechanisms[propertyName].forEach(function(m) {
          if (m.user_chosed && m.type == "STRUCTURE") {
            m.user_checked = "accepted";
          }
        });
      }

      for (var propertyName in this.mechanisms) {
        this.mechanisms[propertyName].forEach(function(m) {
          if (!m.user_checked || !m.user_chosed) {
            isValid = false;
          }
        });
      }

      if (!isValid) {
        if (this.sanctionCeckedYear == parseInt(this.selectedYear) || this.isPeriodValidation) {
          return swal({
            type: "warning",
            title: "Figyelem!",
            html:
              "<p>A kötelezően meg kell adni egy alapértelmezett értéket (igen/nem) minden esetben!</p>",
            confirmButtonColor: "#3fa535",
            confirmButtonText: "Rendben"
          });
        } else {
          return swal({
            type: "warning",
            title: "Figyelem!",
            html:
              "<p>A kötelezően meg kell adni egy alapértelmezett értéket (igen/nem) minden esetben!</p>"+
              "<p>Valamint minden választható szankciónál csak első évben lehet megadni, hogy választotta-e. A következő években már csak a teljesülést tudja módosítani.</p>",
            confirmButtonColor: "#3fa535",
            confirmButtonText: "Rendben"
          });
        }
      }

      //   for (var propertyName in this.mechanisms) {
      //     this.mechanisms[propertyName].forEach(function(mechanism) {
      //       if (
      //         mechanism.specification_type &&
      //         mechanism.user_chosed == "not_accepted"
      //       ) {
      //         isValid = false;
      //         mechanism.valid = false;

      //         swal({
      //           type: "warning",
      //           title: "Figyelem!",
      //           html: "A kötelező típusú mezőket kötelezően be kell jelölni!",
      //           confirmButtonColor: "#3fa535",
      //           confirmButtonText: "Rendben"
      //         });
      //       }
      //     });
      //   }

      //   loop1: for (let propertyName in this.mechanisms) {
      //     var grupedMechanisms = this.mechanisms[propertyName];
      //     grupedMechanisms.forEach(function(mechanism) {
      //       if (mechanism.dependency_mechanism_id !== null) {
      //         var relatedMechanism = _.find(grupedMechanisms, function(m) {
      //           return m.id == mechanism.dependency_mechanism_id;
      //         });

      //         if (
      //           relatedMechanism.user_chosed == "not_accepted" &&
      //           mechanism.user_chosed == "not_accepted"
      //         ) {
      //           isValid = false;
      //           relatedMechanism.valid = false;
      //           swal({
      //             type: "warning",
      //             title: "Figyelem!",
      //             html:
      //               "A vagylagos előírásoknál, kötelező választani az egyik előírást!",
      //             confirmButtonColor: "#3fa535",
      //             confirmButtonText: "Rendben"
      //           });
      //         }
      //       }
      //     });
      //   }

      if (isValid) {
        this.handleSubmit();
      }
    },

    checkIsRelation(s1, s2) {
      if (typeof s2 === "undefined") {
        return false;
      }

      if (s1.dependency_mechanism_id === s2.id) {
        return true;
      }
      return false;
    },

    getTitle() {
      if (this.selectedYear == "2016") {
        return this.selectedYear + "-os évben vállalt előírások megadása";
      }
      return this.selectedYear + "-es évben vállalt előírások megadása";
    },
    handleSubmit() {
      if (this.sanctionType === "ANNUALLY") {
        return this.validateColumnSanctions();
      }

      if (this.sanctionType === "FULL_TIME" && this.isPeriodValidation) {
        return this.checkUserProgramSanctions();
      }
    },

    swalLoaderShow() {
      swal({
        title: "Kis türelmet!",
        confirmButtonColor: "#3fa535",
        text: "A szankciók kiértékelése folyamatban...",
        allowOutsideClick: () => !swal.isLoading(),
        onOpen: () => {
          swal.showLoading();
        }
      });
    },

    checkUserProgramSanctions() {
      this.$refs.modal.hide();
      //   this.swalLoaderShow();
      this.$emit("validatePeriodSanctions", this.selectedIds);
    },

    validateColumnSanctions() {
      this.$refs.modal.hide();
      //   this.swalLoaderShow();
      this.$emit("validateColumnSanctions", this.selectedIds);
    },

    onHidden(evt) {
      this.$emit("close");
    },
    close() {
      swal({
        title: "Biztosan elhagyja a kérdőívet?",
        text:
          "Ha a „Mégsem” gombbal elhagyja a kérdőívet, akkor nem kalkulál szankciókat a program!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        confirmButtonColor: "#3fa435",
        cancelButtonText: "Nem"
      }).then(result => {
        if (result.value) {
          this.$emit("close");
        }
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/AgrotechnicalMechanism.vue